var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('plan-upgrade-dialog',{attrs:{"value":Boolean(_vm.upgradePrompt) && _vm.ready,"prompt":_vm.upgradePrompt,"plan":_vm.plan,"choose-plan":_vm.isFree},on:{"input":_vm.onInput,"go-to-plan":_vm.goToPlan,"go-to-plans":_vm.goToPlans}})}
var staticRenderFns = []

export { render, staticRenderFns }